import { Stepper, styled } from "@mui/material";


export const StyledStepper = styled(Stepper)({
  marginTop: 24
});